module.exports = __webpack_public_path__ + "static/img/Source-placeholder.4c0b21da.jpg";